// Checks whether the given password is 9 characters long
export const hasPasswordLength = (
  newPassword: string,
  confirmNewPassword: string
) => newPassword.length > 9 && confirmNewPassword.length > 9;

// Checks whether the given password contains a number / symbol
export const hasLettersNumbersSymbols = (
  newPassword: string,
  confirmNewPassword: string
) =>
  /^(?=.*\d)(?=.*[a-z|A-Z]).{8,}$/.test(newPassword) &&
  /^(?=.*\d)(?=.*[a-z|A-Z]).{8,}$/.test(confirmNewPassword);

// Checks whether the given password contains an upper and a lower case letter
export const hasUpperAndLowerCase = (
  newPassword: string,
  confirmNewPassword: string
) =>
  /[a-z]/.test(newPassword) &&
  /[A-Z]/.test(newPassword) &&
  /[a-z]/.test(confirmNewPassword) &&
  /[A-Z]/.test(confirmNewPassword);
